import { createDownloadLinkService } from './service/DowloadLinkService';
import { extendObj } from '@golden/utils';
import { createBaseModule, Branch, createMemoService, createQRCodeService, createTrunkService, createExchangeRateService, createSocket } from '@golden/gdk-base';
import { createAuthService } from './service/AuthService';
import { createAnnouncementService } from './service/AnnouncementService';
import { createPermissionRoleService } from './service/PermissionRoleService';
import { createEmperorService } from './service/EmperorService';
import { createParameterService } from './service/ParameterService';
import { createPlatformService } from './service/PlatformService';
import { createAdminService } from './service/AdminService';
import { createFinanceService } from './service/FinanceService';
import { createGreetingService } from './service/GreetingService';
import { createHistoryService } from './service/HistoryService';
import { createJumpShipService } from './service/JumpShipService';
import { createNotificationService } from './service/NotificationService';
import { createAlertService } from './service/AlertService';
import { createRealTimeService } from './service/RealTimeService';
import { createDepositService } from './service/DepositService';
import { createWithdrawService } from './service/WithdrawService';
import { createPlayerService } from './service/PlayerService';
import { createManualService } from './service/ManualService';
import { map, filter, BehaviorSubject } from 'rxjs';
import { createActivityService } from './service/ActivityService';
import { createSmsService } from './service/SmsService';
import { createAdminSocketService } from './service/SocketService';
import { createAgentWalletService } from './service/AgentWalletService';
import { createFeatureFlagService } from './service/FeatureFlagService';
import { createJointVentureSettingService } from './service/JointVentureSettingService';
export function createAdminModule(baseURL, wsURL, timeout, lang) {
    const socket = createSocket(wsURL, { transports: ['websocket', 'polling'], path: '/ws/socket.io', autoConnect: false });
    const baseModule = createBaseModule(baseURL, timeout, lang);
    const isWrongSubject = new BehaviorSubject(false);
    const trunk = createTrunkService(baseModule.isLoginSubject, (isLogged) => (obs) => obs.pipe(map(([branches, handleError]) => [
        branches.filter((branch) => branch === Branch.ADMIN_STATUS || (isLogged.value && !isWrongSubject.value)),
        handleError
    ]), filter(([branches]) => branches.length !== 0)));
    const auth = createAuthService(baseModule.api, trunk, baseModule.isLoginSubject, isWrongSubject);
    const admin = createAdminService(baseModule.api, trunk);
    const finance = createFinanceService(baseModule.api, trunk);
    const platform = createPlatformService(baseModule.api, trunk);
    const alert = createAlertService(baseModule.api, trunk);
    const noRealTimeAgentModule = extendObj(baseModule, {
        auth,
        trunk,
        admin,
        memo: createMemoService(baseModule.api),
        announcement: createAnnouncementService(baseModule.api),
        downloadLink: createDownloadLinkService(baseModule.api),
        jointVentureSetting: createJointVentureSettingService(baseModule.api),
        alert,
        notification: createNotificationService(baseModule.api),
        sms: createSmsService(baseModule.api),
        permissionRole: createPermissionRoleService(baseModule.api),
        emperor: createEmperorService(baseModule.api),
        jumpShip: createJumpShipService(baseModule.api),
        player: createPlayerService(baseModule.api, trunk),
        parameter: createParameterService(baseModule.api),
        platform,
        finance,
        deposit: createDepositService(baseModule.api),
        withdraw: createWithdrawService(baseModule.api, trunk),
        manual: createManualService(baseModule.api),
        greeting: createGreetingService(baseModule.api),
        history: createHistoryService(baseModule.api),
        activity: createActivityService(baseModule.api, trunk),
        qrcode: createQRCodeService(baseModule.api),
        exchangeRate: createExchangeRateService(baseModule.api),
        agentWallet: createAgentWalletService(baseModule.api),
        featureFlag: createFeatureFlagService(baseModule.api)
    });
    const realTimeService = createRealTimeService(baseModule.api, trunk, noRealTimeAgentModule);
    const adminModule = extendObj(noRealTimeAgentModule, {
        socket: createAdminSocketService(baseModule.api, socket, trunk, admin, finance, platform, alert, auth, realTimeService),
        get legacyMode() {
            return realTimeService.isEnable;
        },
        set legacyMode(value) {
            realTimeService.isEnable = value;
        }
    });
    adminModule.legacyMode = true;
    return adminModule;
}
//# sourceMappingURL=AdminModule.js.map